import React from 'react';

export const ListSvg = (props: { fillColor: string }) => {
  const { fillColor = '#252525' } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25391 7.30781C8.25391 6.94797 8.54562 6.65625 8.90547 6.65625H19.3305C19.6904 6.65625 19.9821 6.94797 19.9821 7.30781C19.9821 7.66766 19.6904 7.95938 19.3305 7.95938H8.90547C8.54562 7.95938 8.25391 7.66766 8.25391 7.30781Z"
        fill={fillColor}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25391 11.8664C8.25391 11.5066 8.54562 11.2148 8.90547 11.2148H19.3305C19.6904 11.2148 19.9821 11.5066 19.9821 11.8664C19.9821 12.2263 19.6904 12.518 19.3305 12.518H8.90547C8.54562 12.518 8.25391 12.2263 8.25391 11.8664Z"
        fill={fillColor}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25391 16.4289C8.25391 16.0691 8.54562 15.7773 8.90547 15.7773H19.3305C19.6904 15.7773 19.9821 16.0691 19.9821 16.4289C19.9821 16.7888 19.6904 17.0805 19.3305 17.0805H8.90547C8.54562 17.0805 8.25391 16.7888 8.25391 16.4289Z"
        fill={fillColor}
      />

      <path
        d="M5.97735 7.95469C6.51712 7.95469 6.95469 7.51712 6.95469 6.97735C6.95469 6.43757 6.51712 6 5.97735 6C5.43757 6 5 6.43757 5 6.97735C5 7.51712 5.43757 7.95469 5.97735 7.95469Z"
        fill={fillColor}
      />

      <path
        d="M5.97735 12.5133C6.51712 12.5133 6.95469 12.0757 6.95469 11.5359C6.95469 10.9962 6.51712 10.5586 5.97735 10.5586C5.43757 10.5586 5 10.9962 5 11.5359C5 12.0757 5.43757 12.5133 5.97735 12.5133Z"
        fill={fillColor}
      />

      <path
        d="M5.97735 17.0797C6.51712 17.0797 6.95469 16.6421 6.95469 16.1023C6.95469 15.5626 6.51712 15.125 5.97735 15.125C5.43757 15.125 5 15.5626 5 16.1023C5 16.6421 5.43757 17.0797 5.97735 17.0797Z"
        fill={fillColor}
      />
    </svg>
  );
};
